module.exports = __webpack_public_path__ + "static/img/短视频-人物剧情短视频.c62dde4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/短视频-人物剧情短视频.png
// module id = bPe5
// module chunks = 1